// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IUnmatchedPushTotalBalanceResponse,
} from '../models/index';
import {
    IUnmatchedPushTotalBalanceResponseFromJSON,
    IUnmatchedPushTotalBalanceResponseToJSON,
} from '../models/index';

export interface GetTotalBalanceGetUnmatchedPushTransactionsTotalBalanceRequest {
    organizationId: number;
}

/**
 * UnmatchedPushTransactionsControllerApi - interface
 * 
 * @export
 * @interface UnmatchedPushTransactionsControllerApiInterface
 */
export interface UnmatchedPushTransactionsControllerApiInterface {
    /**
     * Returns the total balance of the given organization\'s unapplied push clearing account. The organization_id is required.
     * @summary Get total balance of unmatched push transactions for an organization
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnmatchedPushTransactionsControllerApiInterface
     */
    getTotalBalanceGetUnmatchedPushTransactionsTotalBalanceRaw(requestParameters: GetTotalBalanceGetUnmatchedPushTransactionsTotalBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IUnmatchedPushTotalBalanceResponse>>;

    /**
     * Returns the total balance of the given organization\'s unapplied push clearing account. The organization_id is required.
     * Get total balance of unmatched push transactions for an organization
     */
    getTotalBalanceGetUnmatchedPushTransactionsTotalBalance(requestParameters: GetTotalBalanceGetUnmatchedPushTransactionsTotalBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IUnmatchedPushTotalBalanceResponse>;

}

/**
 * 
 */
export class UnmatchedPushTransactionsControllerApi extends runtime.BaseAPI implements UnmatchedPushTransactionsControllerApiInterface {

    /**
     * Returns the total balance of the given organization\'s unapplied push clearing account. The organization_id is required.
     * Get total balance of unmatched push transactions for an organization
     */
    async getTotalBalanceGetUnmatchedPushTransactionsTotalBalanceRaw(requestParameters: GetTotalBalanceGetUnmatchedPushTransactionsTotalBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IUnmatchedPushTotalBalanceResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getTotalBalanceGetUnmatchedPushTransactionsTotalBalance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organization_id'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/unmatched-push-transactions/total-balance`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IUnmatchedPushTotalBalanceResponseFromJSON(jsonValue));
    }

    /**
     * Returns the total balance of the given organization\'s unapplied push clearing account. The organization_id is required.
     * Get total balance of unmatched push transactions for an organization
     */
    async getTotalBalanceGetUnmatchedPushTransactionsTotalBalance(requestParameters: GetTotalBalanceGetUnmatchedPushTransactionsTotalBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IUnmatchedPushTotalBalanceResponse> {
        const response = await this.getTotalBalanceGetUnmatchedPushTransactionsTotalBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
